import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import $ from 'jquery';
@Component({
  selector: 'app-rename-custom-peergroup',
  templateUrl: './rename-custom-peergroup.component.html',
  styleUrls: ['./rename-custom-peergroup.component.scss'],
})
export class RenameCustomPeergroupComponent {
  peerGroupName: string = '';
  @Input() peerGroup: any;
  validatePattern =  '^(?! )[A-Za-z0-9^@#$!`\\-\'~_.\\+]+(?: [A-Za-z0-9^@#$!`\\-\'~_.\\+]+)*$';
  validations: any;

  constructor(public activeModal: NgbActiveModal) {
    this.validations = {
      validatePattern: {
        pattern: 'Error:  Input can only contain alphanumeric and  the following special characters : ^@#$!`~\'-_.+ are allowed',
      }
    };
  }

  ngOnInit() {
    this.peerGroupName = this.peerGroup.pgname;
    setTimeout(() => {
      $('.close').focus();
    }, 100);
  }
}
